import { render, staticRenderFns } from "./ClickFlags.vue?vue&type=template&id=3e39036d&scoped=true&lang=pug"
import script from "./ClickFlags.vue?vue&type=script&lang=ts"
export * from "./ClickFlags.vue?vue&type=script&lang=ts"
import style0 from "./ClickFlags.vue?vue&type=style&index=0&id=3e39036d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e39036d",
  null
  
)

export default component.exports